import React from 'react';
import { useCountUp } from '../lib/useCountUp';
import { useSplitReveal } from '../lib/useSplitReveal';
import { useScrollReveal } from '../lib/useScrollReveal';

/* Figures carried over from the existing site's own claims. */
const FIGURES = [
  { value: '500+', label: 'personal shops already built' },
  { value: '1', label: 'photo to get your palette' },
  { value: 'Free', label: 'to join while we are in early access' },
] as const;

/* Own component so each figure can hold its own count-up ref. */
const Figure: React.FC<{ value: string; label: string; divided: boolean }> = ({
  value,
  label,
  divided,
}) => {
  const number = useCountUp<HTMLParagraphElement>(value);

  return (
    <div
      className={`flex flex-col justify-end py-4 sm:py-10 ${
        divided ? 'border-t border-line sm:border-l sm:border-t-0 sm:pl-8 lg:pl-12' : ''
      }`}
    >
      <p
        ref={number}
        className="display text-[clamp(2.25rem,9vw,6rem)] font-medium text-ink tabular-nums"
      >
        {value}
      </p>
      <p className="mt-2 max-w-[24ch] text-[14px] leading-relaxed text-muted sm:mt-3 sm:text-[15px]">{label}</p>
    </div>
  );
};

const ProofBar: React.FC = () => {
  const heading = useSplitReveal<HTMLHeadingElement>({ onScroll: true });
  const figures = useScrollReveal<HTMLDivElement>({ selector: ':scope > div', y: 22, stagger: 0.1 });

  return (
    <section className="screen items-stretch">
      <div className="shell flex flex-col justify-between py-8 lg:py-16">
        <h2
          ref={heading}
          className="display split-target max-w-[14ch] text-[clamp(1.75rem,7vw,3rem)] font-medium text-ink"
        >
          Where early access stands today.
        </h2>

        {/* Columns run the full height so the figures anchor the baseline. */}
        <div
          ref={figures}
          className="mt-6 grid flex-1 grid-cols-1 border-t border-line sm:mt-16 sm:grid-cols-3"
        >
          {FIGURES.map((figure, i) => (
            <Figure key={figure.value} value={figure.value} label={figure.label} divided={i > 0} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProofBar;
